var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import classNames from 'classnames';
import 'chartjs-adapter-date-fns';
import { Line } from 'react-chartjs-2';
import { chartColors } from '../../../style/vars/colors';
import { getLineTooltipFooter, getLineTooltipTitle, tickCallback, } from '../chartHelpers';
import { StyledLineChart } from './lineChart.linaria';
import { defaultProps, lineChartDefaultOptions } from './defaultProps';
import { useGradientData } from './hooks/useGradientData';
function LineChart(_a) {
    var { data, chartOptions, className, height, calculationType = 'basic', lineColor = chartColors.darkGreen, dotColor = chartColors.green, dotBorderColor = chartColors.white, dotRadius = 8, dotBorderWidth = 4, tickColor = chartColors.text, yAxisSuffix = '%', xAxisSuffix, gradient, xAxisTitle } = _a, props = __rest(_a, ["data", "chartOptions", "className", "height", "calculationType", "lineColor", "dotColor", "dotBorderColor", "dotRadius", "dotBorderWidth", "tickColor", "yAxisSuffix", "xAxisSuffix", "gradient", "xAxisTitle"]);
    const chartRef = useRef();
    const chartData = useGradientData(chartRef, gradient.data, data);
    const options = Object.assign({}, (chartOptions || lineChartDefaultOptions));
    options.elements.line.borderColor = lineColor;
    options.elements.point = Object.assign(Object.assign({}, options.elements.point), { hoverBackgroundColor: dotColor, hoverBorderColor: dotBorderColor, radius: dotRadius, hoverRadius: dotRadius, borderWidth: dotBorderWidth, hoverBorderWidth: dotBorderWidth });
    options.scales.y.ticks.callback = tickCallback(yAxisSuffix);
    options.scales.x.ticks.callback = tickCallback(xAxisSuffix);
    options.plugins.tooltip.callbacks = {
        footer: getLineTooltipFooter(yAxisSuffix, calculationType),
        title: getLineTooltipTitle(xAxisSuffix),
    };
    options.scales.y.ticks.color = tickColor;
    options.scales.x.ticks.color = tickColor;
    if (xAxisTitle && options.scales.x.title) {
        options.scales.x.title.text = xAxisTitle;
    }
    return (<StyledLineChart {...props} height={height} className={classNames([className])}>
      <Line ref={chartRef} data={chartData} options={options}/>
    </StyledLineChart>);
}
LineChart.defaultProps = defaultProps;
export default LineChart;
